import { useEffect, useState } from "react";

interface Props {
  show: boolean;
  onClose: () => void;
}

export function ConfettiPopup({ show, onClose }: Props) {
  const [particles, setParticles] = useState<Array<{
    id: number;
    left: number;
    animationDuration: number;
    color: string;
  }>>([]);

  useEffect(() => {
    if (show) {
      // Generate confetti particles
      const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#6c5ce7', '#a29bfe', '#fd79a8'];
      const newParticles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        animationDuration: 2 + Math.random() * 2,
        color: colors[Math.floor(Math.random() * colors.length)],
      }));
      setParticles(newParticles);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
      {/* Transparent backdrop - click handler on popup instead */}

      {/* Confetti particles */}
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="confetti-particle"
          style={{
            left: `${particle.left}%`,
            animationDuration: `${particle.animationDuration}s`,
            backgroundColor: particle.color,
          }}
        />
      ))}

      {/* Popup */}
      <div className="relative bg-white rounded-lg shadow-2xl p-8 max-w-md w-full mx-4 text-center transform animate-bounce-in pointer-events-auto">
        <div className="text-6xl mb-4">🎉</div>
        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          Congratulations!
        </h2>
        <p className="text-lg text-gray-600 mb-6">
          You've completed the crossword!
        </p>
        <button
          onClick={onClose}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
        >
          Awesome!
        </button>
      </div>

      <style>{`
        .confetti-particle {
          position: absolute;
          width: 10px;
          height: 10px;
          top: -10px;
          animation: fall linear infinite;
        }

        @keyframes fall {
          to {
            transform: translateY(100vh) rotate(360deg);
            opacity: 0;
          }
        }

        @keyframes bounce-in {
          0% {
            transform: scale(0.3);
            opacity: 0;
          }
          50% {
            transform: scale(1.05);
          }
          70% {
            transform: scale(0.9);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

        .animate-bounce-in {
          animation: bounce-in 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }
      `}</style>
    </div>
  );
}
